import { gql } from "lib/apolloClient";
import { aiFragment } from "./LessonPlanningFragments";

export const createAIConversationMutation = gql`
  mutation createAIConversation($input: CreateAiConversationInput!) {
    ai {
      createAiConversation(input: $input) {
        isSuccess
        response {
          id
          entityType
          entitySubType
          metadata
        }
      }
    }
  }
`;

export const createBulkAiMessagesMutation = gql`
  mutation createBulkAiMessages($input: CreateBulkAiMessagesInput!) {
    ai {
      createBulkAiMessages(input: $input) {
        isSuccess
        response {
          ...aiMessageItem
        }
      }
    }
  }
  ${aiFragment.aiMessage}
`;

export const createAIMessageMutation = gql`
  mutation createAiMessage($input: CreateAiMessageInput!) {
    ai {
      createAiMessage(input: $input) {
        isSuccess
        response {
          ...aiMessageItem
        }
      }
    }
  }
  ${aiFragment.aiMessage}
`;

export const updateAIMessageMutation = gql`
  mutation updateAiMessage($input: UpdateAiMessageInput!) {
    ai {
      updateAiMessage(input: $input) {
        isSuccess
        response {
          ...aiMessageItem
        }
      }
    }
  }
  ${aiFragment.aiMessage}
`;
